import {
  AnalyticsError,
  AnalyticsPage,
  AnalyticsProfile,
  AnalyticsSiteAssets,
  AnalyticsUser,
  ClickEventAnalytics,
  PageLoadAnalytics,
  PageLoadErrorAnalytics
} from '../../models/utils/analytics.interfaces';

export const adobePageAnalyticsMocks: AnalyticsPage = {
  info: {
    page_name: 'dal:homepage',
    page_url: '/',
    page_type: 'homepage',
    previous_page_name: '',
    previous_page_url: '',
    section: '',
    sub_section: 'no-subsection',
    country: 'us',
    language: 'en',
    sys_env: 'responsive'
  }
};

export const adobeProfileAnalyticsMocks: AnalyticsProfile = {
  skymiles_number: '23476762474',
  skymiles_tier: 'GM',
  amex_card_type: 'Gold',
  available_miles: '67890000',
  email: 'test123@gmail.com'
};

export const adobeUserAnalyticsMocks: AnalyticsUser = {
  attributes: {
    is_logged_in: 'unauthenticated'
  }
};

export const adobeUserLoggedInAnalyticsMocks: AnalyticsUser = {
  attributes: {
    is_logged_in: 'authenticated',
    login_method: 'user name',
    login_state: 'hot'
  },
  profile: adobeProfileAnalyticsMocks
};

export const adobeErrorAnalyticsMocks: AnalyticsError = {
  type: 'home page load error',
  code: '01024',
  message: `sorry, we’re currently unable to display your content`
};

export const adobeSiteAssetsAnalyticsMocks: AnalyticsSiteAssets[] = [
  {
    type: 'banner',
    position: '1',
    name: 'fast free wifi and so much more',
    value: '896.5',
    miles: '11,900',
    fare_type: 'money',
    currency_code: 'usd'
  },
  {
    type: 'hero',
    position: '1',
    name: 'HOW CAN I CANCEL/CHANGE MY FLIGHT?'
  },
  {
    type: 'tile',
    position: '1',
    name: 'OUR ONBOARD EXPERIENCE'
  },
  {
    type: 'tile',
    position: '2',
    name: 'READY FOR ADVENTURE?'
  },
  {
    type: 'tile',
    position: '3',
    name: 'TREAT YOURSELF TO PREMIUM TRAVEL'
  },
  {
    type: 'hero',
    position: '2',
    name: 'EXPLORE DESTINATIONS & TRAVEL REQUIREMENTS'
  },
  {
    type: 'hero',
    position: '3',
    name: 'EVERYTHING YOU NEED, ALL IN ONE PLACE'
  },
  {
    type: 'hero',
    position: '4',
    name: 'BUY $300 IN DELTA GIFT CARDS, GET A $20 BONUS'
  }
];

export const adobePageLoadAnalyticsMocks: PageLoadAnalytics = {
  event_detail: 'homepage',
  event: 'page-load',
  page: adobePageAnalyticsMocks,
  user: adobeUserLoggedInAnalyticsMocks,
  site_assets: adobeSiteAssetsAnalyticsMocks
};

export const adobeClickEventAnalyticsMocks: ClickEventAnalytics = {
  event_detail: '',
  event: 'click',
  click: {
    name: '',
    type: 'button',
    page_section: 'test-section',
    action: ''
  },
  user: adobeUserAnalyticsMocks
};

export const adobePageLoadErrorAnalyticsMocks: PageLoadErrorAnalytics = {
  event_detail: 'homepage',
  event: 'page-load',
  page: adobePageAnalyticsMocks,
  user: adobeUserAnalyticsMocks,
  error: adobeErrorAnalyticsMocks
};
